import MenuIcon from "@mui/icons-material/Menu";
import {
	AppBar,
	Box,
	Button,
	CircularProgress,
	Grid,
	IconButton,
	Toolbar,
	Typography,
	useScrollTrigger,
	useTheme,
} from "@mui/material";
import { cloneElement, PropsWithChildren, Suspense, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import HeroHeader from "../../styles/HeroHeader";
import Footer from "../Footer";
import Navigator from "../../components/Navigator";
import { BACKGROUND_COLOR } from "../../styles/Theme";
import SmartOceanLogo from "../../assets/img/SmartOcean-White.png";

const HEXADECIMAL_BACKGROUND_TRANSPARENCY = "88"; // 136/255 ~ 53%

function ScrollHandler(props: any) {
	const theme = useTheme();
	const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 0 });

	return cloneElement(props.children, {
		style: {
			backgroundColor: trigger
				? theme.palette.primary.main + HEXADECIMAL_BACKGROUND_TRANSPARENCY
				: "transparent",
		},
	});
}

export default function OpenPageLayout(props: PropsWithChildren<{}>) {
	const theme = useTheme();
	const [menuOpen, setMenuOpen] = useState<boolean>(false);

	const handleMenuToggle = () => {
		setMenuOpen(!menuOpen);
	};

	return (
		<Box minHeight="100vh" display="flex" flexDirection="column" bgcolor={BACKGROUND_COLOR}>
			<HeroHeader />
			<Navigator variant="temporary" open={menuOpen} onClose={handleMenuToggle} />
			<ScrollHandler>
				<AppBar position="fixed" elevation={0}>
					<Toolbar>
						<Grid container spacing={1} alignItems="center">
							<Grid item>
								<Button component={Link} to="/">
									<img src={SmartOceanLogo} alt="SmartOcean" height="30px" />
								</Button>
							</Grid>
							<Grid item xs />
							<Grid item>
								<IconButton
									color="inherit"
									aria-label="open drawer"
									onClick={handleMenuToggle}
									edge="start"
								>
									<MenuIcon sx={{ height: theme.spacing(6), width: theme.spacing(6) }} />
								</IconButton>
							</Grid>
						</Grid>
					</Toolbar>
				</AppBar>
			</ScrollHandler>
			<Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
				<Box component="main" sx={{ flex: 1, px: { sm: 4, xs: 0 } }}>
					<Suspense fallback={<CircularProgress />}>
						{props.children}
						<Outlet />
					</Suspense>
				</Box>
				<Footer />
			</Box>
		</Box>
	);
}
